/**
 * 分页
 */
export type PageParams = {
  current?: number;
  pageSize?: number;
};
export type SorterParams = {
  sorter?: Record<string, any>;

}
export type FilterParams = {
  filter?: Record<string, any[]>;
}

/**
 * 字典
 */
export type Dict = {
  category: string;
  code: string;
  description: string;
  id: number;
  name: string;
  sort: number;
  updateTime: string;
}

/**
 * 消息中心
 */

export enum MessageInfoTypeEnum {
  '通知' = 1,
  '公告' = 2
};
export type MessageInfoType = 1 | 2;


export type MessageInfo = {
  content: string;
  createTime: string;
  deleted: boolean;
  id: number;
  img: string;
  readFlag: boolean;
  relateData: any;
  subType: string;
  targetPerson: string;
  type: MessageInfoType;
};
